import React from 'react';
import clsx from 'clsx';
import PopUp from 'components/PopUps/PopUp';
import PopUpContent from 'components/PopUps/PopUpContent';
import Button from 'components/Button';
import styles from './ConfirmPopup.module.scss';

export interface ConfirmPopupProps {
  title: string;
  message: React.ReactNode;
  confirmText: string;
  declineText: string;
  onPopupClose: () => void;
  onConfirmClick: () => void;
  loading?: boolean;
  confirmButtonClassName?: string;
  declineButtonClassName?: string;
  subMessage?: string;
  warningText?: string;
  titleTooltip?: React.ReactNode;
  usePortal?: boolean;
}

const ConfirmPopup = ({
  message,
  title,
  confirmText,
  declineText,
  onPopupClose,
  onConfirmClick,
  loading,
  confirmButtonClassName,
  declineButtonClassName,
  subMessage,
  usePortal,
  warningText,
  titleTooltip,
}: ConfirmPopupProps) => {
  return (
    <PopUp usePortal={usePortal} closePopUp={onPopupClose} title={title} closable={!loading} warningText={warningText} titleTooltip={titleTooltip}>
      <PopUpContent hasTopMargin>
        <div className={styles.contentMessage}>{message}</div>
        {subMessage && <p className={clsx(styles.contentMessage, styles.subMessage)}>{subMessage}</p>}
        <div className={styles.buttonsContainer}>
          <Button
            isLoading={loading}
            kind="primary"
            size="form"
            className={clsx(styles.confirmButton, confirmButtonClassName)}
            onClick={onConfirmClick}
          >
            {confirmText}
          </Button>
          <Button
            disabled={loading}
            kind="secondary"
            size="form"
            className={clsx(styles.declineButton, declineButtonClassName)}
            onClick={onPopupClose}
          >
            {declineText}
          </Button>
        </div>
      </PopUpContent>
    </PopUp>
  );
};

export default ConfirmPopup;
